import type { DocumentTagsTableCellFragment } from "../client/generated";
import { DocumentTableCell } from "./DocumentTableCell";
import { DocumentTags } from "./DocumentTags";

type Props = {
  fragment: DocumentTagsTableCellFragment;
};

export function DocumentTagsTableCell({ fragment }: Props) {
  return (
    <DocumentTableCell className="flex flex-col gap-2">
      <DocumentTags fragment={fragment} />
    </DocumentTableCell>
  );
}
